module.exports = __webpack_public_path__ + "img/users.21d99911.svg";